import { gql } from "@apollo/client";

export const FETCH_CREATIVES = gql`
  query FetchCreatives(
    $dateRange: JSONObject!
    $attributionMethod: String!
    $granularity: String!
    $nbAccountingMode: String!
    $timeGranularity: String!
    $attributionWindow: String!
    $platforms: [CreativePlatformEnum!]!
    $metricFilters: CreativesMetricsFilterInput
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $groupByName: Boolean
    $sortedAdKeys: [String!]
    $adKeys: [String!]
    $dateCompression: Boolean
    $offset: Int
    $limit: Int
    $searchText: String
    $status: CreativesStatusEnum
    $creativeType: CreativesTypeEnum
    $sorting: CreativesSortingInput
  ) {
    me {
      creatives(
        dateRange: $dateRange
        attributionMethod: $attributionMethod
        granularity: $granularity
        nbAccountingMode: $nbAccountingMode
        timeGranularity: $timeGranularity
        attributionWindow: $attributionWindow
        platforms: $platforms
        metricFilters: $metricFilters
        breakdownFilters: $breakdownFilters
        groupByName: $groupByName
        sortedAdKeys: $sortedAdKeys
        adKeys: $adKeys
        dateCompression: $dateCompression
        offset: $offset
        limit: $limit
        searchText: $searchText
        status: $status
        creativeType: $creativeType
        sorting: $sorting
      ) {
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }

        rows {
          dimensions
          dailyMetrics
          name
          status
          adKey
          previewAdKey
          imageUri
          adName
          adsetName
          campaignName
        }
        hasMore
      }
    }
  }
`;

export const FETCH_CUSTOM_GOALS = gql`
  query FetchCustomGoals {
    me {
      customGoals {
        goals {
          id
          displayName
        }
      }
    }
  }
`;

export const FETCH_CREATIVE_SAVED_VIEWS = gql`
  query FetchCreativeSavedViews {
    me {
      creativeSavedViews {
        views {
          id
          name
          isDefault
          config {
            heroMetric
            metrics
            attributionWindow
            attributionModel
            groupByAdName
            dateRange
            platforms
            sorting
            sortingOrder
            status
            creativeType
            searchText
            metricFilters
            breakdownFilters
          }
        }
      }
    }
  }
`;

export const UPSERT_CREATIVE_SAVED_VIEWS = gql`
  mutation UpsertCreativeAnalyticsSavedViews(
    $views: [UpsertCreativeSavedView!]!
  ) {
    upsertCreativeAnalyticsSavedViews(views: $views) {
      successMessage
    }
  }
`;

export const UPSERT_CREATIVE_SAVED_VIEWS_ORDERING_TO_ALL_ACCOUNT_MANAGERS = gql`
  mutation UpsertCreativeAnalyticsSavedViewsOrderingToAllAccountManagers(
    $ids: [Int!]!
  ) {
    upsertCreativeAnalyticsSavedViewsOrderingToAllAccountManagers(ids: $ids) {
      successMessage
    }
  }
`;

export const FETCH_CREATIVE_PREVIEWS = gql`
  query FetchCreativePreviews($adKey: String!) {
    me {
      creativePreviews(adKey: $adKey) {
        previews
      }
    }
  }
`;

export const FETCH_METRIC_PERCENTILES = gql`
  query FetchMetricPercentiles(
    $dateRange: JSONObject!
    $attributionMethod: String!
    $granularity: String!
    $nbAccountingMode: String!
    $timeGranularity: String!
    $attributionWindow: String!
    $platforms: [CreativePlatformEnum!]!
    $metrics: [CreativesMetricInput!]!
    $groupByName: Boolean
    $searchText: String
    $status: CreativesStatusEnum
    $creativeType: CreativesTypeEnum
  ) {
    me {
      metricPercentiles(
        dateRange: $dateRange
        attributionMethod: $attributionMethod
        granularity: $granularity
        nbAccountingMode: $nbAccountingMode
        timeGranularity: $timeGranularity
        attributionWindow: $attributionWindow
        platforms: $platforms
        metrics: $metrics
        groupByName: $groupByName
        searchText: $searchText
        status: $status
        creativeType: $creativeType
      ) {
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }

        metrics {
          platform
          metricId
          p0
          p5
          p10
          p15
          p20
          p25
          p30
          p35
          p40
          p45
          p50
          p55
          p60
          p65
          p70
          p75
          p80
          p85
          p90
          p95
          p100
        }
      }
    }
  }
`;
